/* eslint-disable jsx-a11y/anchor-is-valid */

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAuthentication } from "../context/Authentication";
import logoAcumar from "./img/logo_acumar_blanco.png";
import Anchor from "./controls/Anchor";
import { useEffect, useState } from "react";

export default function NavBar({ ...props }) {
  const { authenticated, loadUserProfile, logout } = useAuthentication();
  const [userProfile, setUserProfile] = useState(null);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const handleExitItemClick = (event) => {
    event.preventDefault();
    logout({ redirectUri: window.location.origin});
  };

  const handleHomeClick = (event) => {
    event.preventDefault();
    navigate("/");
  };
  const handleMisTramitesClick = (event) => {
    event.preventDefault();
    navigate("/reportes/tramites");
  };
  useEffect(() => {
    loadUserProfile()
      .then((profile) => {
        setUserProfile(profile);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  return (
    <nav className="navbar navbar-top navbar-default">
      <div>
        <div className="navbar-header">
          <img src={logoAcumar} alt="Logo Acumar" />
        </div>
        <div
          className="collapse navbar-collapse"
          id="main-menu-collapse"
          data-section="main"
        >
          <ul className="nav navbar-nav navbar-right">
            {authenticated && (
              <>
                <li className="dropdown">
                  <Anchor
                    className="dropdown-toggle"
                    data-toggle="dropdown"
                    role="button"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    {userProfile?.username} <i className="fa fa-user"></i>
                  </Anchor>
                  <ul className="dropdown-menu" style={{ minWidth: "320px" }}>
                    <li
                      className="dropdown-header"
                      style={{
                        marginTop: "10px",
                        marginBottom: "10px",
                        fontSize: "16px",
                        color: "#ffffff",
                      }}
                    >{`${userProfile?.username}-${userProfile?.firstName}`}</li>
                    <li role="separator" className="divider" />
                    <li>
                      <Anchor onClick={handleHomeClick}>
                        {t("usuario.inicio")}
                      </Anchor>
                    </li>

                    <li>
                      <Anchor onClick={handleMisTramitesClick}>
                        {t("usuario.misTramites")}
                      </Anchor>
                    </li>

                    <li>
                      <Anchor onClick={handleExitItemClick}>
                        {t("usuario.salir")}
                      </Anchor>
                    </li>
                  </ul>
                </li>
              </>
            )}
            {!authenticated && (
              <li>
                <Anchor>Home</Anchor>
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
}
